// extracted by mini-css-extract-plugin
module.exports = {"container":"_2Exmh8iA4XSMkLyQk2qpUW","icon":"_3eaoZUKOAsWtIEeKZp7Uwj"};